




























































































import { Component, Watch } from "vue-property-decorator";
import { container } from "@/services/registerServiceProvider";
import { IStatisticService } from "@/services/IStatisticService";
import ChartLine from "@/components/Chart/ChartLine.vue";
import { price } from "@/components/filters/Format";
import { ChartData, ChartOptions } from "chart.js";
import { declensionOfNum } from "@/components/filters/Literal";
import { Statistic } from "@/models/Statistic";
import { mixins } from "vue-class-component";
import { DateRangeFilterMixin } from "@/mixins/DateRangeFilterMixin";

@Component({
  components: { ChartLine },
  filters: { price },
})
export default class HomeSalesStatistics extends mixins(DateRangeFilterMixin) {
  statistic: Statistic[] | null = null;
  chartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      displayColors: false,
      callbacks: {
        label: item => {
          return `${item.label} - ${item.value} продаж${declensionOfNum(
            Number(item.value),
            ["а", "и", ""],
          )}`;
        },
        title: () => "",
      },
    },
    plugins: {
      legend: false,
    },
    elements: {
      line: {
        tension: 0,
      },
    },
    scales: {
      xAxes: [
        {
          gridLines: {
            display: true,
          },
        },
      ],
      yAxes: [
        {
          gridLines: {
            display: true,
          },
        },
      ],
    },
  };

  private readonly statisticService: IStatisticService = container.resolve(
    "IStatisticService",
  );

  get chartData(): ChartData | null {
    const stat = this.statistic?.find(e => e.label === "Продажи");
    if (!stat) {
      return null;
    }
    return {
      labels: stat.chart.dates.map(e => {
        const [y, m, d] = e.split("-");
        return `${d}.${m}`;
      }),
      datasets: [
        {
          backgroundColor: "#A6CEE3",
          borderColor: "#A6CEE3",
          data: stat.chart.values,
          fill: false,
        },
      ],
    };
  }

  async loadStatistic() {
    if (this.date?.length) {
      const [fromDate, toDate] = this.date;
      this.statistic = null;
      this.statistic = await this.statisticService.getSales(fromDate, toDate);
    }
  }

  get totalSales() {
    return this.statistic?.find(e => e.label === "Продажи")?.value;
  }

  get totalSum() {
    return this.statistic?.find(e => e.label === "Премии")?.value;
  }

  get totalAntiSegment() {
    return this.statistic?.find(e => e.label === "Антисегмент")?.value;
  }

  @Watch("date", { deep: true, immediate: true })
  private async onDateChange(val: []) {
    if (val) {
      this.dateModal = [...val];
      await this.loadStatistic();
    }
  }
}
